/* tslint:disable */
/* eslint-disable */
/**
 * Customer Journey Endpoints
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface GetCalculationCommandResult
 */
export interface GetCalculationCommandResult {
	/**
	 *
	 * @type {string}
	 * @memberof GetCalculationCommandResult
	 */
	state?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof GetCalculationCommandResult
	 */
	repairAmountCurrency?: string | null;
	/**
	 *
	 * @type {number}
	 * @memberof GetCalculationCommandResult
	 */
	repairAmount?: number | null;
	/**
	 *
	 * @type {number}
	 * @memberof GetCalculationCommandResult
	 */
	repairAmountGross?: number | null;
	/**
	 *
	 * @type {number}
	 * @memberof GetCalculationCommandResult
	 */
	sparePartCosts?: number | null;
	/**
	 *
	 * @type {number}
	 * @memberof GetCalculationCommandResult
	 */
	labourCosts?: number | null;
	/**
	 *
	 * @type {number}
	 * @memberof GetCalculationCommandResult
	 */
	labourCostsDiscount?: number | null;
	/**
	 *
	 * @type {number}
	 * @memberof GetCalculationCommandResult
	 */
	lacquerCosts?: number | null;
	/**
	 *
	 * @type {number}
	 * @memberof GetCalculationCommandResult
	 */
	lacquerCostsDiscount?: number | null;
	/**
	 *
	 * @type {number}
	 * @memberof GetCalculationCommandResult
	 */
	lacquerMatCosts?: number | null;
	/**
	 *
	 * @type {number}
	 * @memberof GetCalculationCommandResult
	 */
	lacquerMatCostsDiscount?: number | null;
	/**
	 *
	 * @type {number}
	 * @memberof GetCalculationCommandResult
	 */
	additionalCosts?: number | null;
	/**
	 *
	 * @type {number}
	 * @memberof GetCalculationCommandResult
	 */
	smallCosts?: number | null;
	/**
	 *
	 * @type {number}
	 * @memberof GetCalculationCommandResult
	 */
	retention?: number | null;
	/**
	 *
	 * @type {number}
	 * @memberof GetCalculationCommandResult
	 */
	replacementAmount?: number | null;
	/**
	 *
	 * @type {number}
	 * @memberof GetCalculationCommandResult
	 */
	valueReductionAmount?: number | null;
	/**
	 *
	 * @type {number}
	 * @memberof GetCalculationCommandResult
	 */
	repairTime?: number | null;
}

/**
 * Check if a given object implements the GetCalculationCommandResult interface.
 */
export function instanceOfGetCalculationCommandResult(
	value: object
): value is GetCalculationCommandResult {
	return true;
}

export function GetCalculationCommandResultFromJSON(json: any): GetCalculationCommandResult {
	return GetCalculationCommandResultFromJSONTyped(json, false);
}

export function GetCalculationCommandResultFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): GetCalculationCommandResult {
	if (json == null) {
		return json;
	}
	return {
		state: json['state'] == null ? undefined : json['state'],
		repairAmountCurrency:
			json['repairAmountCurrency'] == null ? undefined : json['repairAmountCurrency'],
		repairAmount: json['repairAmount'] == null ? undefined : json['repairAmount'],
		repairAmountGross: json['repairAmountGross'] == null ? undefined : json['repairAmountGross'],
		sparePartCosts: json['sparePartCosts'] == null ? undefined : json['sparePartCosts'],
		labourCosts: json['labourCosts'] == null ? undefined : json['labourCosts'],
		labourCostsDiscount:
			json['labourCostsDiscount'] == null ? undefined : json['labourCostsDiscount'],
		lacquerCosts: json['lacquerCosts'] == null ? undefined : json['lacquerCosts'],
		lacquerCostsDiscount:
			json['lacquerCostsDiscount'] == null ? undefined : json['lacquerCostsDiscount'],
		lacquerMatCosts: json['lacquerMatCosts'] == null ? undefined : json['lacquerMatCosts'],
		lacquerMatCostsDiscount:
			json['lacquerMatCostsDiscount'] == null ? undefined : json['lacquerMatCostsDiscount'],
		additionalCosts: json['additionalCosts'] == null ? undefined : json['additionalCosts'],
		smallCosts: json['smallCosts'] == null ? undefined : json['smallCosts'],
		retention: json['retention'] == null ? undefined : json['retention'],
		replacementAmount: json['replacementAmount'] == null ? undefined : json['replacementAmount'],
		valueReductionAmount:
			json['valueReductionAmount'] == null ? undefined : json['valueReductionAmount'],
		repairTime: json['repairTime'] == null ? undefined : json['repairTime'],
	};
}

export function GetCalculationCommandResultToJSON(json: any): GetCalculationCommandResult {
	return GetCalculationCommandResultToJSONTyped(json, false);
}

export function GetCalculationCommandResultToJSONTyped(
	value?: GetCalculationCommandResult | null,
	ignoreDiscriminator: boolean = false
): any {
	if (value == null) {
		return value;
	}

	return {
		state: value['state'],
		repairAmountCurrency: value['repairAmountCurrency'],
		repairAmount: value['repairAmount'],
		repairAmountGross: value['repairAmountGross'],
		sparePartCosts: value['sparePartCosts'],
		labourCosts: value['labourCosts'],
		labourCostsDiscount: value['labourCostsDiscount'],
		lacquerCosts: value['lacquerCosts'],
		lacquerCostsDiscount: value['lacquerCostsDiscount'],
		lacquerMatCosts: value['lacquerMatCosts'],
		lacquerMatCostsDiscount: value['lacquerMatCostsDiscount'],
		additionalCosts: value['additionalCosts'],
		smallCosts: value['smallCosts'],
		retention: value['retention'],
		replacementAmount: value['replacementAmount'],
		valueReductionAmount: value['valueReductionAmount'],
		repairTime: value['repairTime'],
	};
}
